import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../services/api'
import { useToast } from '@chakra-ui/react'

async function onUpdateDadosNegociacao(data) {
  const res = await api.put('/site/v2/orcamento-crm/atualiza-dados-negociacao', data)
  return res.data
}

export function useUpdateNegociacao() {
  const toast = useToast({
    position: 'top-right',
  })

  const queryClient = useQueryClient()

  return useMutation(onUpdateDadosNegociacao, {
    onSuccess: () => {
      queryClient.invalidateQueries('negociacao-historico')
      toast({
        title: 'Alterado com sucesso!',
        status: 'success',
      })
    },
    onError: (error) => {
      console.error('Erro ao atualizar os dados da negociação:', error)
      toast({
        title: 'Erro ao alterar!',
        status: 'error',
      })
    },
  })
}
